// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"29f8d229","952":"e905acd9"}[chunkId] + ".chunk.css";
};